module.exports = __webpack_public_path__ + "static/media/kuslers_homepage.43ed2224.png";